import * as bootstrap from "bootstrap";

let handlers = [];

const navListItems = document.querySelectorAll(".desktop");

function toggleSubMenu(navListItem) {
  navListItem.addEventListener('mouseover', function(){
    const navSubMenu = navListItem.querySelector("#submenu");
    navSubMenu.classList.add("nav-submenu-show");
    navListItem.classList.add("nav-list-item-label--hover");
  })

  navListItem.addEventListener('mouseout', function(){
    const navSubMenu = navListItem.querySelector("#submenu");
    navSubMenu.classList.remove("nav-submenu-show");
    navListItem.classList.remove("nav-list-item-label--hover");
  })
}

for (const navListItem of navListItems) {
  toggleSubMenu(navListItem);
}

const navSettings = document.querySelector(".action")
const navSettingsDropdown = document.querySelector(".action-account-dropdown")
const navSettingsLabel = document.querySelector(".action-account-settings")


if(navSettings){
  function openSettingsDropdown(navSettings) {
    navSettings.addEventListener('mouseover', function(){
      navSettingsDropdown.classList.add("action-account-dropdown-show");
      navSettingsLabel.classList.add("action-account-settings-hover");
    })
  
    navSettings.addEventListener('mouseout', function(){
      navSettingsDropdown.classList.remove("action-account-dropdown-show");
      navSettingsLabel.classList.remove("action-account-settings-hover");
    })
  }
  
  openSettingsDropdown(navSettings)
  
}


// mobile toggle icon
let openMenu = document.querySelector(".nav-toggler-open");
if (openMenu) {
  function openMenuHandler() {
    document.body.classList.add("mobile-nav--open");
    toggleBodyScrolling();
  }
  openMenu.addEventListener("click", openMenuHandler);
  handlers.push(() => openMenu.removeEventListener("click", openMenuHandler));
}

let closeMenu = document.querySelector(".nav-toggler-close");

if (closeMenu) {
  function closeMenuHandler() {
    document.body.classList.remove("mobile-nav--open");
    toggleBodyScrolling();
  }
  closeMenu.addEventListener("click", closeMenuHandler);
  handlers.push(() => closeMenu.removeEventListener("click", closeMenuHandler));
}

let documentScrollY = 0;

function toggleBodyScrolling() {
  const body = document.body;
  body.classList.toggle("overflow-hidden");

  window.scrollTo(0, documentScrollY);
}

const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

export default {};
